import { __assign } from "tslib";
var isLongKey = function (key) { return key.length > 20; };
export function createSettingsParams(settings) {
    var keys = Object.keys(settings);
    if (process.env.NODE_ENV === 'development') {
        var longKeys = keys.filter(function (key) { return isLongKey(settings[key].key || key); });
        if (longKeys.length) {
            console.warn("Seems like you are trying to create settings params using long keys (more than 20 characters). This can cause the Public Data size limitation. Please consider renaming keys ".concat(longKeys.join(', '), "."));
        }
    }
    return keys.reduce(function (acc, key) {
        acc[key] = __assign(__assign({}, settings[key]), { key: settings[key].key || key });
        return acc;
    }, {});
}
export var createSettingsParam = function (key, param) { return (__assign({ key: key }, param)); };
//# sourceMappingURL=createSettingsParams.js.map